module.exports = __webpack_public_path__ + "media/images/link-white-icon-54b8b5cd5704a1676bd373dc9d49ac28.png";